import { format, min, parse, startOfYear, sub, isBefore, isValid } from 'date-fns';
import get from 'lodash/fp/get';
import pick from 'lodash/fp/pick';
import head from 'lodash/fp/head';
import compose from 'lodash/fp/compose';

import * as dateFnLocales from 'date-fns/locale';
import { getDateFnsLocale } from 'config/languages';

const maxEmployeeStay = 8;
const limitRoomNightDays = 30;

export const getInfoToRetrieveSoonestBooking = compose(
	pick(['reservationId', 'hotelCode']),
	get(['hotelProducts', '0']),
	head
);

export const formatToTwelveHours = (date, locale) =>
	format(date, 'h:mma', {
		locale: dateFnLocales[getDateFnsLocale(locale)],
	}).toLowerCase();

export const parseDateWithTime = date => parse(date, 'yyyy-MM-dd HH:mm', new Date());

export const parseDate = dateStr => {
	if (dateStr?.length === 10) {
		const dateReturn = parse(dateStr, 'yyyy-MM-dd', new Date());
		if (isValid(dateReturn)) {
			return dateReturn;
		}
	}
	return undefined;
};

export const getEmployeeServiceDateForYear = (employee, year) => {
	if (employee?.serviceDate?.length === 10) {
		let dateFromServiceDate = parse(
			`${year}${employee.serviceDate.substring(4, 10)}`,
			'yyyy-MM-dd',
			new Date()
		);
		if (isValid(dateFromServiceDate)) {
			return dateFromServiceDate;
		}
		if (employee.serviceDate.substring(5, 10) === '02-29') {
			dateFromServiceDate = parse(`${year}-03-01`, 'yyyy-MM-dd', new Date());
			if (isValid(dateFromServiceDate)) {
				return dateFromServiceDate;
			}
		}
	}
	return undefined;
};

export const getDateForEmployeeStayHistory = (stayHistoryMonths, employee) => {
	let dateFromServiceDate = getEmployeeServiceDateForYear(employee, new Date().getFullYear());
	if (dateFromServiceDate) {
		if (isBefore(sub(new Date(), { days: 1 }), dateFromServiceDate)) {
			dateFromServiceDate = getEmployeeServiceDateForYear(employee, new Date().getFullYear() - 1);
			if (dateFromServiceDate) {
				return format(sub(dateFromServiceDate, { days: maxEmployeeStay - 1 }), 'yyyy-MM-dd');
			}
		} else {
			return format(sub(dateFromServiceDate, { days: maxEmployeeStay - 1 }), 'yyyy-MM-dd');
		}
	}
	return format(sub(new Date(), { months: stayHistoryMonths }), 'yyyy-MM-dd');
};

export const getDateForEmployeeRoomNights = (
	{ checkIn = format(new Date(), 'yyyy-MM-dd'), checkOut = format(new Date(), 'yyyy-MM-dd') } = {},
	employeeProfile
) => {
	let arriveStartFromService;
	let dateFromServiceDate = getEmployeeServiceDateForYear(
		employeeProfile,
		new Date().getFullYear()
	);
	if (dateFromServiceDate) {
		if (isBefore(new Date(), dateFromServiceDate)) {
			dateFromServiceDate = getEmployeeServiceDateForYear(
				employeeProfile,
				new Date().getFullYear() - 1
			);
			if (dateFromServiceDate) {
				arriveStartFromService = dateFromServiceDate;
			}
		} else {
			arriveStartFromService = dateFromServiceDate;
		}
	}

	return format(
		sub(
			min([
				...(arriveStartFromService ? [arriveStartFromService] : []),
				startOfYear(parse(checkIn, 'yyyy-MM-dd', new Date())),
				sub(parse(checkOut, 'yyyy-MM-dd', new Date()), {
					days: limitRoomNightDays,
				}),
			]),
			{ days: maxEmployeeStay - 1 }
		),
		'yyyy-MM-dd'
	);
};
